<template>
  <pf-grid gutter>
    <template v-for="(feature, key) of allFeatures">
      <pf-grid-item
        v-if="product[key] || product[key] === 0"
        :key="key"
        :span="key === 'descrizione' ? 12 : 4"
      >
        <component v-if="feature.icon" :is="feature.icon" />
        <product-feature :feature="key" :product="product" show-label />
      </pf-grid-item>
    </template>
  </pf-grid>
</template>

<script lang="ts" setup>
import ProductFeature, { getAllProductFeatures } from "./product-feature.vue";
import type { ComponentProps } from "vue-component-type-helpers";

type ProductFeatureProps = ComponentProps<typeof ProductFeature>;

defineProps<{
  product: ProductFeatureProps["product"];
}>();

const allFeatures = getAllProductFeatures();
</script>
